import React, { useState, useEffect, useCallback } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {
  ErrorDisplay,
  Loading,
  SuccessDisplay,
  FormButtons,
  ICONS,
} from '../../../components'
import { GSXService } from '../../../services'
import { OrderDataGrid } from './orders_grid'

import { reduxForm } from 'redux-form'
import * as GSXFilters from '../../filters'
import { ORDER_STATUS_GROUP_CODE } from '../../constants'
import { connect } from 'react-redux'

const OrdersFilterHTML = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props
  return (
    <form onSubmit={handleSubmit}>
      <GSXFilters.DateFilter name="createdFromDate" label="Created From" />
      <GSXFilters.DateFilter name="createdToDate" label="Created To" />
      <GSXFilters.StringFilter name="orderId" label="Order Id" />
      <GSXFilters.StringFilter name="partNumber" label="Part Number" />
      <GSXFilters.StringFilter name="poNumber" label="PO Number" />

      <GSXFilters.StringFilter name="shipTo" label="Ship To" />
      <GSXFilters.OptionsField
        name="orderStatusGroupCode"
        label="Order Status Group Code"
        options={ORDER_STATUS_GROUP_CODE}
      />

      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

export const OrdersFilter = reduxForm({
  // a unique name for the form
  form: 'gsx-orders-filter',
})(OrdersFilterHTML)

export const OrderDataGridModal = ({ searchData, inline, buttonText }) => {
  const [show, setShow] = useState(false)

  const [loading, setLoading] = useState([])
  const [sizePerPage] = useState(10)
  const [setCurrentPage] = useState(1)
  const [totalNumberOfRecords, setTotalNumberOfRecords] = useState([])
  const [consignedOrders, setConsignedOrders] = useState([])
  const [errors, setErrors] = useState([])
  const handleClose = () => setShow(false)
  const getResultsFromAPI = useCallback(
    (data) => {
      setLoading(true)
      setConsignedOrders([])
      new GSXService()
        .consignment_order_lookup(data)
        .then((response) => {
          const { totalNumberOfRecords, consignedOrders } = response
          setConsignedOrders(consignedOrders || [])
          setLoading(false)
          setErrors(null)
          setTotalNumberOfRecords(totalNumberOfRecords)
        })
        .catch((errors) => {
          setConsignedOrders([])
          setLoading(false)
          setTotalNumberOfRecords(0)
          setErrors(errors)
        })
    },
    [setLoading, setConsignedOrders, setErrors, setTotalNumberOfRecords]
  )
  const onFilter = (values) => {
    let data = {
      pageNumber: 1,
      sizePerPage: sizePerPage,
      fetchAllRepairs: false,
      search_criteria: { ...searchData, ...values },
    }
    getResultsFromAPI(data)
  }
  const handleShow = useCallback(
    (type, f) => {
      let data = {
        pageNumber: 1,
        sizePerPage: sizePerPage,
        search_criteria: searchData,
      }

      if (f) {
        const { page, sizePerPage } = f
        data.pageNumber = page
        data.sizePerPage = sizePerPage
        setCurrentPage(page)
      }

      setShow(true)
      getResultsFromAPI(data)
    },
    [sizePerPage, searchData, setCurrentPage, setShow, getResultsFromAPI]
  )

  useEffect(() => {
    if (inline) {
      handleShow()
    }
  }, [searchData, inline, buttonText, handleShow])

  const getBody = () => {
    return (
      <>
        {loading ? <Loading /> : ''}
        {errors && !loading ? <ErrorDisplay error={errors} /> : ''}
        {consignedOrders.length > 0 ? (
          <OrderDataGrid
            onTableChange={handleShow}
            sizePerPage={sizePerPage}
            data={consignedOrders}
            count={totalNumberOfRecords}
          />
        ) : (
          <SuccessDisplay message={'No Previous Orders found.'} />
        )}
      </>
    )
  }

  if (!inline)
    return (
      <>
        <ReactBootstrap.Modal
          size="xl"
          backdrop="static"
          show={show}
          onHide={handleClose}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Orders</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>{getBody()}</ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer></ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>

        <ReactBootstrap.NavDropdown.Item
          onClick={(e) => {
            handleShow()
          }}
        >
          <i class="fas fa-list-ol"></i> {buttonText ? buttonText : 'Orders'}
        </ReactBootstrap.NavDropdown.Item>
      </>
    )

  const OrdersFilterFormWithData = searchData
    ? connect(() => ({
        initialValues: { ...searchData },
      }))(OrdersFilter)
    : OrdersFilter
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>
            {' '}
            {`GSX Orders (${totalNumberOfRecords})`}
          </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={6} className="bg-dark  text-end text-dark">
            <GSXFilters.SearchModal
              modalHeading={'Search Orders'}
              buttonIcon={ICONS.SEARCH}
              mode="button"
            >
              <OrdersFilterFormWithData onSubmit={onFilter} />
            </GSXFilters.SearchModal>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>{getBody()}</ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
